/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

const HOVER_TIME_REPORTING_THRESHOLD_IN_SECONDS = 1;

interface TrackHoverContainerArgs {
  hoverReportingThresholdInSeconds?: number;
  onTrack?: (time: number) => unknown;
  trackDestroy?: boolean;
}

export default class TrackHoverContainer extends Component<TrackHoverContainerArgs> {
  @tracked isHovering = false;
  @tracked hoverStart = 0;

  get hoverReportingThresholdInSeconds() {
    return this.args.hoverReportingThresholdInSeconds ?? HOVER_TIME_REPORTING_THRESHOLD_IN_SECONDS;
  }

  @action
  onMouseEnter() {
    if (this.isHovering) {
      return;
    }

    this.hoverStart = Date.now();
    this.isHovering = true;
  }

  @action
  onMouseLeave() {
    if (!this.isHovering) {
      return;
    }

    let now = Date.now();

    let hoverTimeInMilliseconds = now - this.hoverStart;
    let hoverTimeInSeconds = hoverTimeInMilliseconds / 1000;

    let roundedToOneDecimal = Math.round(hoverTimeInSeconds * 10) / 10;

    if (roundedToOneDecimal >= this.hoverReportingThresholdInSeconds && this.args.onTrack) {
      this.args.onTrack(roundedToOneDecimal);
    }

    this.isHovering = false;
    this.hoverStart = 0;
  }

  willDestroy() {
    super.willDestroy();

    if (this.args.trackDestroy === true && this.hoverStart !== 0) {
      this.onMouseLeave();
    }
  }
}
